import { __ } from '@wordpress/i18n';

const {
	SelectControl
} = wp.components


const { Component, Fragment } = wp.element

import googleFonts from "../components/fonts"
import Nexter_Icons from "../components/icons"

function nexter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FontFamilyControl extends Component{
	
	constructor(props) {
		super(props)
		
		this.state = {
			showFonts : false,
			SearchText: '',
			showWeights : false,
			customFontList : [],
			googleFontList : [],
		}
		
		this.handleClickOutside = (e) => {
			const { showFonts, showWeights } = this.state
			if (showFonts) {
				let fontselect = this.refs.nexterSelectFontFamily,
					FontList = this.refs.nexterFontList;
				
				if(FontList && !FontList.contains(e.target) ){
					{(fontselect && !fontselect.contains(e.target)) &&
						this.setState({
							showFonts: false
						})
					}
				}
			}
			if (showWeights) {
				let fontweight = this.refs.nexterSelectFontWeight,
					FontWeightList = this.refs.nexterFontWeightList;
				
				if(FontWeightList && !FontWeightList.contains(e.target) ){
					{(fontweight && !fontweight.contains(e.target)) &&
						this.setState({
							showWeights: false
						})
					}
				}
			}
		}
	}
	
	getOtherFontFamily(){
		const fonts = wp.hooks.applyFilters( "nexter.custom-font-family-options", [] )
		let gFont = [];
		// if(nexter_blocks_load && nexter_blocks_load.googlefont_load==true){
			gFont = googleFonts;
		// }
		// if(nexter_blocks_load && nexter_blocks_load.googlefont_list && typeof nexter_blocks_load.googlefont_list=='object'){
		// 	fonts.push(nexter_blocks_load.googlefont_list) 
		// }
		// if(nexter_blocks_load && nexter_blocks_load.activeTheme == 'kadence' && typeof kadence_custom_fonts !== 'undefined'){
		// 	if(kadence_custom_fonts.font_families){
		// 		let kad_font = kadence_custom_fonts.font_families;
		// 		let font_opt = []
		// 			Object.keys(kad_font).forEach( (key,index) => {
		// 				font_opt.push({label : kad_font[key].name, value : kad_font[key].name})
		// 			})
		// 		let kadenceFont= {
		// 				id: 'kadence-custom',
		// 				title: __( 'Kadence Fonts'),
		// 				options: font_opt,
		// 			};
		// 		fonts.push(kadenceFont)
		// 	}
		// }
		// if(nexter_blocks_load && nexter_blocks_load.custom_font){
		// 	fonts.push(JSON.parse(nexter_blocks_load.custom_font))
		// }
		this.setState({customFontList: fonts, googleFontList : gFont})
	}
	
	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
		this.getOtherFontFamily()
    }
	
	componentWillUnmount(){
		document.removeEventListener("mousedown", this.handleClickOutside)
	}
	
    setSettings(val, type) {
		const { value, onChange } = this.props
		const { customFontList, googleFontList } = this.state;
		if ("default" == val || "Default" == val){
			if("family" == type){
				delete value.Family,delete value.family, delete value.type
			}else if("fontWeight" == type){
				delete value.fontWeight
			}
			onChange( Object.assign( {}, value ) );
		}else{
			if ("family" == type && val){
				let newval;
				let gFont = '';
				let fontList = [...customFontList,...googleFontList];
				fontList.map( (fonts, index ) => {
					if(!gFont || gFont.length === 0){
						gFont = fonts.options.filter(function (font) {
							if(fonts.id=="nexter-google-fonts"){
								return font.n == val;
							}else{
								return font.value == val;
							}
						})
					}
				})
				val = (newval = {}, nexter_defineProperty(newval, type, val), nexter_defineProperty(newval, 'type', (gFont && gFont[0] && gFont[0].c ? gFont[0].c : (gFont && gFont[0] && gFont[0].value ? gFont[0].value : 'custom'))),nexter_defineProperty(newval, 'customFont', (gFont && gFont[0] && gFont[0].value ? gFont[0].label : '')), newval);
				if(["Default"].concat(this.GetWeightList(val)).indexOf(value.fontWeight) == -1){
					this.setSettings("default","fontWeight")
				}
			}else{
				val = Object.assign(nexter_defineProperty({}, type, val));
			}
			onChange( Object.assign( {}, value, val ) );
			
		}
    }
	
	GetWeightList(updateFamily = '') {
		const {value} = this.props
		const { customFontList, googleFontList } = this.state;
		if(updateFamily ===''){
			updateFamily = (value && value.family && value.family!='default') ? value : '';
		}
		let defaultWeight = [100, 200, 300, 400, 500, 600, 700, 800, 900];
		if(updateFamily && updateFamily.family && updateFamily.family!='default'){
			let gWeight = '';
			let fontList = [...customFontList,...googleFontList];
			fontList.map( (fonts, index ) => {
				gWeight = fonts.options.filter( (font) => {
					if(fonts.id=="nexter-google-fonts"){
						return font.n == updateFamily.family
					}else{
						return font.value == updateFamily.family
					}
				})
			})
			return (gWeight && gWeight[0] && gWeight[0].v) ? gWeight[0].v : defaultWeight
		}else{
			return defaultWeight
		}
	}
	
	
	render() {
		const { showFonts, SearchText, showWeights, customFontList, googleFontList } = this.state;
		const { value } = this.props;
		
		let fontList = [...customFontList,...googleFontList];
		
		if (SearchText.length >= 2) {
			let searchList = [];
			fontList.map( (fonts, index ) => {
				
				let fontsearch = fonts.options.filter( (font) => {
					if(fonts.id=="nexter-google-fonts"){
						return font.n.toLowerCase().search(SearchText.toLowerCase()) !== -1;
					}else{
						return font.label.toLowerCase().search(SearchText.toLowerCase()) !== -1;
					}
				});
				if(fontsearch.length > 0){
					searchList[index] = {id: fonts.id, title: fonts.title, "options": []}
					searchList[index].options = fontsearch
				}
			});
			fontList = searchList
		}
		
		
		const getLoopList = (fontsList,index) => {
			return (<Fragment> 
					{ (fontsList.options && fontsList.options.length>0) && <li className={"nexter-font-title"}>{fontsList.title}</li> }
					{  (fontsList.options && fontsList.options.length>0) && 
						fontsList.options.map( (font,index) => {
							return fontsList.id=="nexter-google-fonts" ?
							(
								<li className={"nexter-font-list-opt"+(font.n == value.family ? ' selected-font' : '')}
									onClick={() => { this.setState({showFonts : false,SearchText: ""}), ("Default" == font.n ? this.setSettings("default","family") : this.setSettings(font.n,"family") ) }}
								>{font.n}</li>
							)
							: 
							 (
								<li className={"nexter-font-list-opt"+(font.value == value.family ? ' selected-font' : '')}
									onClick={() => { this.setState({showFonts : false,SearchText: ""}), ("Default" == font.value ? this.setSettings("default","family") : this.setSettings(font.value,"family") ) }}
								>{font.label}</li>
							)
						})
					}
				</Fragment>)
		}
		
		
		return (
			<div className="nexter-typography-font-family-options">
				<div className="nexter-fonts-weight-inner">
				
					<div className="nexter-font-family-opt">
						<label className="nexter-typography-font-family-label">{ __( "Font Family", 'nexter-extension' ) }</label>
						<div className={"nexter-font-family-wrap"} ref={"nexterSelectFontFamily"} onClick={() => { this.setState({showFonts : !showFonts}) }}>
							<span className={"nexter-font-family-input"}>
								<input type={"text"} value={SearchText} className={"nexter-font-filter"} placeholder={(showFonts ? __('Search', 'nexter-extension') : (value && value.customFont && value.customFont!='') ? value.customFont : value.family || __('Select', 'nexter-extension'))} onChange= {(e) => {
									this.setState({SearchText: e.target.value,showFonts : true})
								}}/>
								<span className={"nexter-font-updown-icon"}>{ Nexter_Icons.arrowDown }</span>
							</span>
						</div>
						{showFonts &&
						<div className={"nexter-fonts-list-wrap"} ref={"nexterFontList"}>
							<ul className={"nexter-font-list-inner"}>
								{ fontList && fontList.length > 0 ?
									fontList.map( (fontsList,index) => {
										return getLoopList(fontsList,index)
									})
									:
									<li className={"nexter-font-list-opt"} onClick={() => { this.setState({showFonts : false,SearchText: ""}) }} >{__('Not Found Font', 'nexter-extension')}</li>
								}
							</ul>
						</div>
						}
					</div>
					
					<div className="nexter-font-weight-opt">
						<label className="nexter-typography-font-weight-label">{ __( "Font Weight", 'nexter-extension' ) }</label>
						<div className={"nexter-font-weight-wrap"} ref={"nexterSelectFontWeight"} onClick={() => { this.setState({showWeights : !showWeights}) }}>
							<div className={"nexter-font-weight-val"} >{((value && value.fontWeight) && value.fontWeight || __('Select', 'nexter-extension'))}</div>
							<span className={"nexter-font-updown-icon"}>{ Nexter_Icons.arrowDown }</span>
						</div>
						{showWeights &&
						<div className={"nexter-weights-list-wrap"} ref={"nexterFontWeightList"}>
							<ul className={"nexter-weight-list-inner"}>
								
								{ ["Default"].concat(this.GetWeightList()).map( (item,index) => {
										return (
											<li className={"nexter-weight-list-opt"+(item == value.fontWeight ? ' selected-weight' : '')}
												onClick={() => { this.setState({showWeights : false}), ("Default" == item ? this.setSettings("default","fontWeight") : this.setSettings(item,"fontWeight") ) }}
											>{item}</li>
										)
									})
								}
							</ul>
						</div>
						}
					</div>
				</div>
			</div>
		)
	}
}
export default FontFamilyControl